import React, { FC } from "react";
import { useParams } from "react-router-dom";

import {
  EmployeeLayout,
  EmployeeLayoutMainContent,
  EmployeeLayoutRightSidebar,
} from "~/components/layouts";

import { BusinessSectionEditForm } from "./components/BusinessSectionEditForm";

export const ManagersBusinessSectionsEdit: FC = () => {
  const { id = "" } = useParams();

  const breadCrumbItems = [
    { label: "課設定", href: "/managers/business_sections" },
    { label: "編集", href: `/managers/business_sections/${id}/edit` },
  ];

  return (
    <EmployeeLayout withRightSidebar breadCrumbItems={breadCrumbItems}>
      <EmployeeLayoutMainContent withRightSidebar>
        <BusinessSectionEditForm businessSectionId={id} />
      </EmployeeLayoutMainContent>
      <EmployeeLayoutRightSidebar />
    </EmployeeLayout>
  );
};
